module.exports = __webpack_public_path__ + "a6383526045378325182164be8a8ec78.svg";